import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Loader } from '@dreamtree-org/twreact-ui';
import { storefrontRoutes } from './routes';
import { enabledRoutes } from './lib/features';
import { StorefrontProvider, useStorefront } from './StorefrontContext';
import StoreLayout from './components/StoreLayout';

/**
 * The merchant's white-label storefront / customer PWA (merchant domain, `/`).
 * A route behind a store feature that is off (D101) is not mounted: its path falls to `*`.
 */
export default function StorefrontApp({ store }) {
  return (
    <StorefrontProvider store={store}>
      <Routes>
        <Route element={<StoreLayout />}>
          {enabledRoutes(storefrontRoutes, store).map(({ path, Element, auth }) => (
            <Route
              key={path}
              path={path}
              element={auth ? <RequireCustomer><Element store={store} /></RequireCustomer> : <Element store={store} />}
            />
          ))}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </StorefrontProvider>
  );
}

/** Customer-only routes: wait for the session, else go to OTP login and come back. */
function RequireCustomer({ children }) {
  const { session, sessionReady } = useStorefront();
  const location = useLocation();
  if (!sessionReady) return <Loader text="Loading…" />;
  if (!session) return <Navigate to={`/account/login?next=${encodeURIComponent(location.pathname + location.search)}`} replace />;
  return children;
}
